<template>
  <div class="container" ref="container">
    <div class="chart">
      <div
        class="gauge"
        :style="{
          width: barWidth,
          left: barPosition
        }"
        :class="{
          high: chartData.value > 0,
          low: chartData.value < 0
        }"
      ></div>
      <div v-for="n of 4" :key="n" class="bar"></div>
    </div>
    <div class="score">{{ chartData.value }}</div>
  </div>
</template>
<style lang="scss" scoped>
.container {
  width: 100%;
  justify-content: flex-start;
  display: flex;
}
.chart {
  flex: 1;
  height: 30px;
  border: 1px solid $instruction-color;
  position: relative;
  display: flex;
  border-right: none;
  div.bar:not(:last-child) {
    border-right: 1px dashed $instruction-color;
  }
  div.bar:nth-child(3) {
    border-right: 1px solid $instruction-color;
  }
}
.bar {
  flex: 1;
}
.score {
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 $spacing-minimum;
  flex: initial;
  border: 1px solid $instruction-color;
}
.gauge {
  position: absolute;
  height: 70%;
  z-index: 9;
  top: 5px;
  background-color: #174a84 !important;
}
</style>
<script lang="ts">
import {} from "d3-color";
import { Prop, Ref } from "vue-property-decorator";
import ChartMixin from "../../helpers/mixins/chart";
export default class GaugeChart extends ChartMixin {
  @Ref("container") readonly container!: HTMLElement;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object, required: true }) chartData: any;

  get barWidth() {
    if (this.chartData.value < -35 || this.chartData.value > 35) {
      return "50%";
    } else {
      return Math.abs((this.chartData.value * 50) / 35) + "%";
    }
  }
  get barPosition() {
    if (this.chartData.value > 0) {
      return "50%";
    } else if (this.chartData.value < -35) {
      return "0%";
    } else {
      return this.chartData.value > 0 ? "50%" : `${50 - (Math.abs(this.chartData.value) * 50) / 35}%`;
    }
  }
}
</script>
